<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>
        Leaderboard
      </mat-card-title>
      <mat-select class="month-select"
                  [(ngModel)]="currentMonth"
                  placeholder="Month"
                  (selectionChange)="filterByMonth($event.value)">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let i of months"
                    [value]="i">{{i}}</mat-option>
      </mat-select>
    </mat-card-header>
    <mat-card-content>
      <div class="list">
        <div class="item"
             *ngFor="let item of data; let i = index;">
          <span>{{ i + 1 }}</span>
          <ifc-avatar-icon mat-list-icon
                           [data]="item.advisor?.avatar"></ifc-avatar-icon>
          <div class="text">
            <span class="text__heading">
              {{ item.totalAmount | currency:'$' }}
            </span>
            <span class="text__second">
              {{ item.advisor?.fullName }}
            </span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ifb-card>
